function addPaddingZeroes(val) {
  const truncatedVal = val.length > 3 ? val.substr(0, 3) : val;

  switch (truncatedVal.length) {
    case 3:
      return truncatedVal;
    case 2:
      return `${truncatedVal}0`;
    case 1:
      return `${truncatedVal}00`;
    default:
      return truncatedVal;
  }
}

/**
 *
 * @param {string} value - input value to convert to percentage string
 * @return {string} value - input value in percentage format
 *
 * Takes input, converts it into a decimal percentage number to two places, then returns it as a string
 *
 * E.g. typing "350" into an input with this listening displays "3.50%" in the input
 */
function formatPercentage(value) {
  const [integer, decimal] = value.split('.');

  // remove any non-numerical characters, set to 0 if nothing entered
  const formattedInteger = integer ? integer.replace(/[^0-9]+/g, 0) : 0;
  const formattedDecimal = decimal ? decimal.replace(/[^0-9]+/g, 0) : 0;

  const paddedDecimal = formattedDecimal
    ? addPaddingZeroes(formattedDecimal.toString())
    : '000';

  const formattedPercentValue = `${formattedInteger}.${paddedDecimal}`;

  return `${formattedPercentValue}%`;

  // const percentValue = (parseFloat(value.replace(/\D/g, '')) / 1000).toFixed(3);
  // value = `${percentValue}%`;

  // return value;
}

export default formatPercentage;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/util/formatPercentage.js